let isSaveProgress = false;
let isExistPostponeCall = false;

const handleOnload = (isSaving, leavePageMessage) => {
  if (isSaving) {
    window.onbeforeunload = (event) => {
      const message = leavePageMessage;
      const e = event || window.event;
      // For IE and Firefox
      if (e) {
        e.returnValue = message;
      }

      // For Safari
      return message;
    };
  } else {
    window.onbeforeunload = null;
  }
};

const setSaveProgress = (
  leavePageMessage,
  val,
  setSendingStatus = () => {},
  launchSaving = () => {}
) => {
  isSaveProgress = val;
  handleOnload(val, leavePageMessage);
  if (!val && isExistPostponeCall) {
    isExistPostponeCall = false;
    launchSaving();
  } else if (!val && !isExistPostponeCall) {
    setSendingStatus(false);
  }
};

const isSaveInProgress = () => {
  if (isSaveProgress) {
    isExistPostponeCall = true;
  }
  return isSaveProgress;
};

export default { isSaveInProgress, setSaveProgress };
